import React, { useEffect, useState, useTransition } from "react";
import { Outlet, useNavigate, useOutletContext } from "react-router-dom";

import Button from "../../../Components/Button/Button";
import CardHeader from "../../../Components/Card/CardHeader";
import Input from "../../../Components/Input/Input";
import RequestFooter from "../../../Components/RequestFooter/RequestFooter";
import Select from "../../../Components/Select/Select";
import TextArea from "../../../Components/TextArea/TextArea";
import Modal from "../../../Components/Modal/Modal";
import SmallCard from "../../../Components/SmallCard/SmallCard";
import Check from "../../../Components/Check/Check";
import EmptyBlock from "../../../Components/EmptyBlock/EmptyBlock";
import CardContainer from "../../../Components/Card/CardContainer";
import CardBody from "../../../Components/Card/CardBody";
import ModalNav from "../../../Components/Modal/ModalNav";

import plus from "../../../icons/plus-violet.svg";
import avatar from "../../../images/Avatar_2.svg";
import avatarBuilding from "../../../images/Avatar_building.svg";
import checkEmpty from "../../../images/Check_Empty.svg";
import checkFilled from "../../../images/Check.svg";
import styles from "./request.create.module.css";
import useRequestContext from "../useRequestContext";
import CustomersModal from "../../Customers/Modal/CustomersModal";
import AddFlSubjectModal from "../FlSubject/AddFlSubjectModal";
import { useFlService } from "../../../Services/FlSubjectService";
import { useUlService } from "../../../Services/UlSubjectService";
import AddUlSubjectModal from "../UlSubject/AddUlSubjectModal";
import AddUlRepresentingFlModal from "../UlRepresentingFl/AddUlRepresentingFlModal";

export default function PropertyRegistration() {
  const [isOpen, setOpen] = useState(false);
  const [flSubjectModal, setFlSubjectModal] = useState(false)
  const [ulSubjectModal, setUlSubjectModal] = useState(false)
  const [selected, setSelected] = useState("fl")
  const [flSubject, setFlSubject] = useState()
  const [ulSubject, setUlSubject] = useState()
  const [ulSubjectId, setUlSubjectId] = useState()
  const [documentTypeCode, setDocumentTypeCode] = useState(0)
  const [ulSubjects, setUlSubjects] = useState([]);
  const [flSubjects, setFlSubjects] = useState([]);
  const [documentDate, setDocumentDate] = useState()
  const [document, setDocument] = useState()
  const [sig, setSig] = useState()
  const { getUlSubjects } = useUlService();
  const { getFlSubjects } = useFlService();
  const [isRepresenting, setRepresenting] = useState(false)

  const { request, setRequest, documentTypes, isDisabled, deleteParticipant, addFlSubject, addFlSubjectWithAgent, addUlAgent, addUlRepresentingFl, addDocumentParticipant } = useRequestContext()
  useEffect(() => {
    getFlSubjects().then(result => setFlSubjects(result))
    getUlSubjects().then(result => setUlSubjects(result))
  }, [])

  const onSaveFl = () => {
    if (!ulSubjectId) {
      addFlSubject(flSubject.Id, request.Id).then(x => {
        const newState = request.Participants;
        const fl = flSubject;
        fl.FlSubject = {
          name: `${flSubject.Lastname} ${flSubject.Firstname} ${flSubject.Middlename}`
        }
        fl.Id = x.data.Id
        newState.push(fl)
        setRequest({ ...request, Participants: newState })
      })
    } else {
      addFlSubjectWithAgent(flSubject.Id, request.Id, documentTypeCode, documentDate, document, sig, ulSubjectId)
    }
  }
  const onUlRepresentingSave = () => {

    addDocumentParticipant(request.Id, ulSubjectId, flSubject.Id)
  }
  const onSaveUl = () => {
    addUlAgent(ulSubject.Id, request.Id, documentTypeCode, documentDate, document, sig).then(x => {
      const newState = request.Participants;
      let ul = ulSubject;
      const ulAgent = ulSubject.Agents.find(x => x.IsMain)
      const documentTypeName = documentTypes.find(x=>x.code===documentTypeCode).name     
      ul = {
        Id:x.data.Id,
        UlAgent: {
          name: `${ulSubject.Name} (${ulAgent ? ulAgent.FioGenitive:"Представитель отсутсвует"})`,

        },
        Document: {
          Type: {
            name: documentTypeName
          }
        }
      }
      console.log(ul)
      newState.push(ul)
      setRequest({ ...request, Participants: newState })
    })
  }
  const onDeleteParticipant = (id) => {
    deleteParticipant(id).then(x => {
      const newState = request.Participants.filter(t => t.Id != id);
      setRequest({ ...request, Participants: newState })
    })
  }
  return (
    <React.Fragment>
      <CardContainer>
        <CardHeader title="Участники" />
        <CardBody>
          {request?.Participants?.length > 0 &&
            <React.Fragment>
              {request?.Participants.filter(x => x.UlAgent != null).map((x) =>
                <SmallCard
                  onRemove={isDisabled ? null : () => onDeleteParticipant(x.Id)}
                  type="default"
                  key={x.Id}
                  title={x.UlAgent.name}
                  subtitle={`Тип документа: ${x.Document.Type.name}`}
                  avatar={avatar}
                />
              )}
              {request?.Participants.filter(x => x.FlSubject != null).map((x) =>
                <SmallCard
                  onRemove={isDisabled ? null : () => onDeleteParticipant(x.Id)}
                  type="default"
                  key={x.Id}
                  title={x.FlAgent ? `${x.FlSubject.name} (Представитель ${x.FlAgent.name})` : x.FlSubject.name}
                  subtitle={`Создан ${x.DateCreate}`}
                  avatar={avatar}
                />
              )}
              {request?.Participants.filter(x => x.UlAgentFlSubject != null).map((x) =>
                <SmallCard
                  onRemove={isDisabled ? null : () => onDeleteParticipant(x.Id)}
                  type="default"
                  key={x.Id}
                  title={x.UlAgentFlSubject.name}
                  avatar={avatar}
                />
              )}
            </React.Fragment>}

          {request?.Participants?.length === 0 &&
            <EmptyBlock title="Текущие участники" />
          }
          {!isDisabled &&
            < Button
              width="100%"
              text="Добавить участника"
              onClick={() => setOpen(true)}
              large
              icon={plus}
              type="primary"
            />
          }

        </CardBody>
      </CardContainer>
      <CustomersModal flSubjects={flSubjects} ulSubjects={ulSubjects} selected={selected} setSelected={setSelected} title="Добавить участника" onClick={(x) => {
        setOpen(false);
        if (selected == "fl") {
          setFlSubject(x)
          setFlSubjectModal(true)
        }
        if (selected == "ul") {
          setUlSubject(x)
          setUlSubjectModal(true)
        }
        if (selected == "representing") {
          setFlSubject(x)
          setRepresenting(true)
        }
      }} setOpen={setOpen} isOpen={isOpen}>

      </CustomersModal>
      <AddUlRepresentingFlModal onSave={onUlRepresentingSave} setUlSubjectId={setUlSubjectId} flSubject={flSubject} ulSubjectId={ulSubjectId} isModal={isRepresenting} setModal={setRepresenting} ulSubjectList={ulSubjects}></AddUlRepresentingFlModal>
      <AddUlSubjectModal onSave={onSaveUl} sig={sig} setSig={setSig} document={document} setDocument={setDocument} documentDate={documentDate} setDocumentDate={setDocumentDate} documentTypeCode={documentTypeCode} setDocumentTypeCode={setDocumentTypeCode} ulSubject={ulSubject} documentTypes={documentTypes} isOpen={ulSubjectModal} setOpen={setUlSubjectModal}></AddUlSubjectModal>
      <AddFlSubjectModal onSave={onSaveFl} sig={sig} setSig={setSig} document={document} setDocument={setDocument} setDocumentDate={setDocumentDate} documentDate={documentDate} setDocumentTypeCode={setDocumentTypeCode} documentTypeCode={documentTypeCode} ulSubjectId={ulSubjectId} flSubject={flSubject} setUlSubjectId={setUlSubjectId} documentTypes={documentTypes} flSubjects={flSubjects} isOpen={flSubjectModal} setOpen={setFlSubjectModal}></AddFlSubjectModal>
    </React.Fragment>
  )
}

